/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.19",
    versionName: "0.2.0-nightly.2025.7.19",
    versionChannel: "nightly",
    buildDate: "2025-07-19T00:07:45.002Z",
    commitHash: "17aaf56d7a8b84bdbdfdc7c9345edd44a519c8b5",
};
